export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Слой_1" x="0px" y="0px" width="17.033px" height="17.001px" viewBox="21.483 -4.001 17.033 17.001" enable-background="new 21.483 -4.001 17.033 17.001" xml:space="preserve" style="&#10;    fill: red;&#10;">
    <polygon fill="${fill ? fill : '#FFFFFF'}" points="33.275,6.449 33.275,7.758 31.965,7.758 31.965,10.377 24.104,10.377 24.104,2.517 26.725,2.517   26.725,1.206 28.034,1.206 28.034,-0.104 24.104,-0.104 21.483,-0.104 21.483,1.206 21.483,10.377 21.483,12.999 21.483,13   24.104,13 24.104,12.999 31.965,12.999 33.275,12.999 33.275,13 34.586,13 34.586,12.999 34.586,10.377 34.586,6.449 " style="&#10;    /* fill: red; */&#10;"/>
    <polygon fill="${fill ? fill : '#FFFFFF'}" points="35.895,-4.001 30.654,-4.001 30.654,-1.38 33.726,-1.38 27.542,4.803 29.664,6.925 35.895,0.694   35.895,3.86 38.516,3.86 38.516,-1.38 38.516,-4.001 "/>
    <head xmlns="" />
  </svg>`
)



// WEBPACK FOOTER //
// ./components/Icon/icons/button/complaint.jsx